import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

// Token storage key constants
const ACCESS_TOKEN_KEY = 'ica_acc';
const REFRESH_TOKEN_KEY = 'ica_rfsh';

export const isEmail = (v: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v.trim());

export const asE164 = (v: string, defaultRegion: CountryCode = 'US') => {
    const phone = parsePhoneNumberFromString(v.trim(), defaultRegion);
    // return phone?.isValid() ? phone.number : null; // "+15551234567"
    return phone?.number;
};

export const isPhone = (v: string) => /^[0-9]{10}$/.test(v.trim());

export type Channel = 'email' | 'sms';

export const detectChannel = (
    loginId: string,
    defaultRegion: CountryCode = 'US'
): { channel: Channel; normalized: string } | null => {
    const t = loginId.trim();
    if (!t) return null;
    if (isEmail(t)) return { channel: 'email', normalized: t.toLowerCase() };
    // const e164 = asE164(t, defaultRegion);
    // if (e164) return { channel: 'sms', normalized: e164 };
    if (isPhone(t)) return { channel: 'sms', normalized: t };
    return null;
};

// Determine environment suffix based on current domain
const getEnvSuffix = () => {
    const isProd = /.app.golendica.com/gi.test(`${window.location}`);
    return isProd ? '' : '_dev';
};

export const TokenType = {
    Refresh: REFRESH_TOKEN_KEY,
    Access: ACCESS_TOKEN_KEY,
} as const;

export type TokenType = (typeof TokenType)[keyof typeof TokenType];

const setToken = (type: TokenType, token: string) => {
    const key = `${type}${getEnvSuffix()}`;
    window.localStorage.setItem(key, token);
};

const getToken = (type: TokenType) => {
    const key = `${type}${getEnvSuffix()}`;
    return window.localStorage.getItem(key);
};

const removeToken = (type: TokenType) => {
    const key = `${type}${getEnvSuffix()}`;
    window.localStorage.removeItem(key);
};

export const refreshToken = {
    set: (token: string) => setToken(TokenType.Refresh, token),
    get: () => getToken(TokenType.Refresh),
    remove: () => removeToken(TokenType.Refresh),
};

export const accessToken = {
    set: (token: string) => setToken(TokenType.Access, token),
    get: () => getToken(TokenType.Access),
    remove: () => removeToken(TokenType.Access),
};
